var getCategoryIcon = function (category) {
    return category &&
        category.assetsMap &&
        category.assetsMap.collectionImage &&
        category.assetsMap.collectionImage.assets &&
        category.assetsMap.collectionImage.assets[0] &&
        category.assetsMap.collectionImage.assets[0].url;
};
export var categoriesCarouselProps = function (categories, t) { return ({
    displayName: t('category.exploreByCategory'),
    innerTagsDefinitions: categories &&
        categories
            .map(function (category) { return category.category; })
            .filter(function (category) { return !category.isHidden; })
            .filter(function (category) { return category.apps.length !== 0; })
            .map(function (category) {
            return {
                name: category.name,
                slug: category.slug,
                description: category.description,
                icon: getCategoryIcon(category),
            };
        }),
}); };
//# sourceMappingURL=categoriesCarouselProps.js.map